/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * mic-service
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AppDeviceVersionRequest,
  AssignUserRole,
  DeleteUser,
  GetApiUsersAppVersionParams,
  GetApiUsersAuditLogParams,
  GetApiUsersDetailParams,
  GetApiUsersValidationParams,
  RegisterUser,
  UpdateUser
} from '.././model';

import { customInstance } from '../../mutator/custom-instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getApiUsersDetail = (
  params?: GetApiUsersDetailParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>({ url: `/api/Users/Detail`, method: 'GET', params, signal }, options);
};

export const getGetApiUsersDetailQueryKey = (params?: GetApiUsersDetailParams) => {
  return [`/api/Users/Detail`, ...(params ? [params] : [])] as const;
};

export const getGetApiUsersDetailQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersDetail>>, TError = unknown>(
  params?: GetApiUsersDetailParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersDetailQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersDetail>>> = ({ signal }) =>
    getApiUsersDetail(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersDetail>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiUsersDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersDetail>>>;
export type GetApiUsersDetailQueryError = unknown;

export function useGetApiUsersDetail<TData = Awaited<ReturnType<typeof getApiUsersDetail>>, TError = unknown>(
  params: undefined | GetApiUsersDetailParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersDetail>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getApiUsersDetail>>, TError, Awaited<ReturnType<typeof getApiUsersDetail>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersDetail<TData = Awaited<ReturnType<typeof getApiUsersDetail>>, TError = unknown>(
  params?: GetApiUsersDetailParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersDetail>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getApiUsersDetail>>, TError, Awaited<ReturnType<typeof getApiUsersDetail>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersDetail<TData = Awaited<ReturnType<typeof getApiUsersDetail>>, TError = unknown>(
  params?: GetApiUsersDetailParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUsersDetail<TData = Awaited<ReturnType<typeof getApiUsersDetail>>, TError = unknown>(
  params?: GetApiUsersDetailParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersDetailQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiUsersProj = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/api/Users/Proj`, method: 'GET', signal }, options);
};

export const getGetApiUsersProjQueryKey = () => {
  return [`/api/Users/Proj`] as const;
};

export const getGetApiUsersProjQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersProj>>, TError = unknown>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProj>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersProjQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersProj>>> = ({ signal }) => getApiUsersProj(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProj>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiUsersProjQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersProj>>>;
export type GetApiUsersProjQueryError = unknown;

export function useGetApiUsersProj<TData = Awaited<ReturnType<typeof getApiUsersProj>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProj>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getApiUsersProj>>, TError, Awaited<ReturnType<typeof getApiUsersProj>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersProj<TData = Awaited<ReturnType<typeof getApiUsersProj>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProj>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getApiUsersProj>>, TError, Awaited<ReturnType<typeof getApiUsersProj>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersProj<TData = Awaited<ReturnType<typeof getApiUsersProj>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProj>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUsersProj<TData = Awaited<ReturnType<typeof getApiUsersProj>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProj>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersProjQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiUsersProd = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/api/Users/Prod`, method: 'GET', signal }, options);
};

export const getGetApiUsersProdQueryKey = () => {
  return [`/api/Users/Prod`] as const;
};

export const getGetApiUsersProdQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersProd>>, TError = unknown>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProd>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersProdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersProd>>> = ({ signal }) => getApiUsersProd(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProd>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiUsersProdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersProd>>>;
export type GetApiUsersProdQueryError = unknown;

export function useGetApiUsersProd<TData = Awaited<ReturnType<typeof getApiUsersProd>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProd>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getApiUsersProd>>, TError, Awaited<ReturnType<typeof getApiUsersProd>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersProd<TData = Awaited<ReturnType<typeof getApiUsersProd>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProd>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getApiUsersProd>>, TError, Awaited<ReturnType<typeof getApiUsersProd>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersProd<TData = Awaited<ReturnType<typeof getApiUsersProd>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProd>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUsersProd<TData = Awaited<ReturnType<typeof getApiUsersProd>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProd>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersProdQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiUsersProdidSection = (prodid: string, options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/api/Users/${prodid}/Section`, method: 'GET', signal }, options);
};

export const getGetApiUsersProdidSectionQueryKey = (prodid?: string) => {
  return [`/api/Users/${prodid}/Section`] as const;
};

export const getGetApiUsersProdidSectionQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersProdidSection>>, TError = unknown>(
  prodid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProdidSection>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersProdidSectionQueryKey(prodid);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersProdidSection>>> = ({ signal }) =>
    getApiUsersProdidSection(prodid, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!prodid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersProdidSection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUsersProdidSectionQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersProdidSection>>>;
export type GetApiUsersProdidSectionQueryError = unknown;

export function useGetApiUsersProdidSection<TData = Awaited<ReturnType<typeof getApiUsersProdidSection>>, TError = unknown>(
  prodid: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProdidSection>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersProdidSection>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersProdidSection>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersProdidSection<TData = Awaited<ReturnType<typeof getApiUsersProdidSection>>, TError = unknown>(
  prodid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProdidSection>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersProdidSection>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersProdidSection>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersProdidSection<TData = Awaited<ReturnType<typeof getApiUsersProdidSection>>, TError = unknown>(
  prodid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProdidSection>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUsersProdidSection<TData = Awaited<ReturnType<typeof getApiUsersProdidSection>>, TError = unknown>(
  prodid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProdidSection>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersProdidSectionQueryOptions(prodid, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiUsersList = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/api/Users/List`, method: 'GET', signal }, options);
};

export const getGetApiUsersListQueryKey = () => {
  return [`/api/Users/List`] as const;
};

export const getGetApiUsersListQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersList>>, TError = unknown>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersList>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersList>>> = ({ signal }) => getApiUsersList(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiUsersListQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersList>>>;
export type GetApiUsersListQueryError = unknown;

export function useGetApiUsersList<TData = Awaited<ReturnType<typeof getApiUsersList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getApiUsersList>>, TError, Awaited<ReturnType<typeof getApiUsersList>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersList<TData = Awaited<ReturnType<typeof getApiUsersList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getApiUsersList>>, TError, Awaited<ReturnType<typeof getApiUsersList>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersList<TData = Awaited<ReturnType<typeof getApiUsersList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUsersList<TData = Awaited<ReturnType<typeof getApiUsersList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiUsersRoleList = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/api/Users/Role/List`, method: 'GET', signal }, options);
};

export const getGetApiUsersRoleListQueryKey = () => {
  return [`/api/Users/Role/List`] as const;
};

export const getGetApiUsersRoleListQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersRoleList>>, TError = unknown>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersRoleList>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersRoleListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersRoleList>>> = ({ signal }) =>
    getApiUsersRoleList(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersRoleList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiUsersRoleListQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersRoleList>>>;
export type GetApiUsersRoleListQueryError = unknown;

export function useGetApiUsersRoleList<TData = Awaited<ReturnType<typeof getApiUsersRoleList>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersRoleList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getApiUsersRoleList>>, TError, Awaited<ReturnType<typeof getApiUsersRoleList>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersRoleList<TData = Awaited<ReturnType<typeof getApiUsersRoleList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersRoleList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersRoleList>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersRoleList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersRoleList<TData = Awaited<ReturnType<typeof getApiUsersRoleList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersRoleList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUsersRoleList<TData = Awaited<ReturnType<typeof getApiUsersRoleList>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersRoleList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersRoleListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiUsersProjidRFIDAccessibility = (
  projid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>({ url: `/api/Users/${projid}/RFIDAccessibility`, method: 'GET', signal }, options);
};

export const getGetApiUsersProjidRFIDAccessibilityQueryKey = (projid?: string) => {
  return [`/api/Users/${projid}/RFIDAccessibility`] as const;
};

export const getGetApiUsersProjidRFIDAccessibilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>,
  TError = unknown
>(
  projid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersProjidRFIDAccessibilityQueryKey(projid);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>> = ({ signal }) =>
    getApiUsersProjidRFIDAccessibility(projid, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!projid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUsersProjidRFIDAccessibilityQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>>;
export type GetApiUsersProjidRFIDAccessibilityQueryError = unknown;

export function useGetApiUsersProjidRFIDAccessibility<
  TData = Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>,
  TError = unknown
>(
  projid: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersProjidRFIDAccessibility<
  TData = Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>,
  TError = unknown
>(
  projid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersProjidRFIDAccessibility<
  TData = Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>,
  TError = unknown
>(
  projid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUsersProjidRFIDAccessibility<
  TData = Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>,
  TError = unknown
>(
  projid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersProjidRFIDAccessibility>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersProjidRFIDAccessibilityQueryOptions(projid, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getApiUsersValidation = (
  params?: GetApiUsersValidationParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>({ url: `/api/Users/Validation`, method: 'GET', params, signal }, options);
};

export const getGetApiUsersValidationQueryKey = (params?: GetApiUsersValidationParams) => {
  return [`/api/Users/Validation`, ...(params ? [params] : [])] as const;
};

export const getGetApiUsersValidationQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersValidation>>, TError = unknown>(
  params?: GetApiUsersValidationParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersValidation>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersValidationQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersValidation>>> = ({ signal }) =>
    getApiUsersValidation(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersValidation>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiUsersValidationQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersValidation>>>;
export type GetApiUsersValidationQueryError = unknown;

export function useGetApiUsersValidation<TData = Awaited<ReturnType<typeof getApiUsersValidation>>, TError = unknown>(
  params: undefined | GetApiUsersValidationParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersValidation>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersValidation>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersValidation>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersValidation<TData = Awaited<ReturnType<typeof getApiUsersValidation>>, TError = unknown>(
  params?: GetApiUsersValidationParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersValidation>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersValidation>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersValidation>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersValidation<TData = Awaited<ReturnType<typeof getApiUsersValidation>>, TError = unknown>(
  params?: GetApiUsersValidationParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersValidation>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUsersValidation<TData = Awaited<ReturnType<typeof getApiUsersValidation>>, TError = unknown>(
  params?: GetApiUsersValidationParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersValidation>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersValidationQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiUsersRegistration = (
  registerUser: RegisterUser,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/Users/Registration`, method: 'POST', headers: { 'Content-Type': 'application/json' }, data: registerUser, signal },
    options
  );
};

export const getPostApiUsersRegistrationMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiUsersRegistration>>, TError, { data: RegisterUser }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersRegistration>>, TError, { data: RegisterUser }, TContext> => {
  const mutationKey = ['postApiUsersRegistration'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersRegistration>>, { data: RegisterUser }> = (props) => {
    const { data } = props ?? {};

    return postApiUsersRegistration(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUsersRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersRegistration>>>;
export type PostApiUsersRegistrationMutationBody = RegisterUser;
export type PostApiUsersRegistrationMutationError = unknown;

export const usePostApiUsersRegistration = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiUsersRegistration>>, TError, { data: RegisterUser }, TContext>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof postApiUsersRegistration>>, TError, { data: RegisterUser }, TContext> => {
  const mutationOptions = getPostApiUsersRegistrationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postApiUsersAssignation = (
  assignUserRole: AssignUserRole,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/Users/Assignation`, method: 'POST', headers: { 'Content-Type': 'application/json' }, data: assignUserRole, signal },
    options
  );
};

export const getPostApiUsersAssignationMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiUsersAssignation>>, TError, { data: AssignUserRole }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersAssignation>>, TError, { data: AssignUserRole }, TContext> => {
  const mutationKey = ['postApiUsersAssignation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersAssignation>>, { data: AssignUserRole }> = (props) => {
    const { data } = props ?? {};

    return postApiUsersAssignation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUsersAssignationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersAssignation>>>;
export type PostApiUsersAssignationMutationBody = AssignUserRole;
export type PostApiUsersAssignationMutationError = unknown;

export const usePostApiUsersAssignation = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiUsersAssignation>>, TError, { data: AssignUserRole }, TContext>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof postApiUsersAssignation>>, TError, { data: AssignUserRole }, TContext> => {
  const mutationOptions = getPostApiUsersAssignationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const putApiUsersModification = (updateUser: UpdateUser, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>(
    { url: `/api/Users/Modification`, method: 'PUT', headers: { 'Content-Type': 'application/json' }, data: updateUser },
    options
  );
};

export const getPutApiUsersModificationMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putApiUsersModification>>, TError, { data: UpdateUser }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof putApiUsersModification>>, TError, { data: UpdateUser }, TContext> => {
  const mutationKey = ['putApiUsersModification'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiUsersModification>>, { data: UpdateUser }> = (props) => {
    const { data } = props ?? {};

    return putApiUsersModification(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiUsersModificationMutationResult = NonNullable<Awaited<ReturnType<typeof putApiUsersModification>>>;
export type PutApiUsersModificationMutationBody = UpdateUser;
export type PutApiUsersModificationMutationError = unknown;

export const usePutApiUsersModification = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof putApiUsersModification>>, TError, { data: UpdateUser }, TContext>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof putApiUsersModification>>, TError, { data: UpdateUser }, TContext> => {
  const mutationOptions = getPutApiUsersModificationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteApiUsersDelete = (deleteUser: DeleteUser, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<void>(
    { url: `/api/Users/Delete`, method: 'DELETE', headers: { 'Content-Type': 'application/json' }, data: deleteUser },
    options
  );
};

export const getDeleteApiUsersDeleteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteApiUsersDelete>>, TError, { data: DeleteUser }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteApiUsersDelete>>, TError, { data: DeleteUser }, TContext> => {
  const mutationKey = ['deleteApiUsersDelete'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiUsersDelete>>, { data: DeleteUser }> = (props) => {
    const { data } = props ?? {};

    return deleteApiUsersDelete(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiUsersDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiUsersDelete>>>;
export type DeleteApiUsersDeleteMutationBody = DeleteUser;
export type DeleteApiUsersDeleteMutationError = unknown;

export const useDeleteApiUsersDelete = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteApiUsersDelete>>, TError, { data: DeleteUser }, TContext>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof deleteApiUsersDelete>>, TError, { data: DeleteUser }, TContext> => {
  const mutationOptions = getDeleteApiUsersDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiUsersAuditLog = (
  params?: GetApiUsersAuditLogParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>({ url: `/api/Users/AuditLog`, method: 'GET', params, signal }, options);
};

export const getGetApiUsersAuditLogQueryKey = (params?: GetApiUsersAuditLogParams) => {
  return [`/api/Users/AuditLog`, ...(params ? [params] : [])] as const;
};

export const getGetApiUsersAuditLogQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersAuditLog>>, TError = unknown>(
  params?: GetApiUsersAuditLogParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersAuditLog>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersAuditLogQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersAuditLog>>> = ({ signal }) =>
    getApiUsersAuditLog(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersAuditLog>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiUsersAuditLogQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersAuditLog>>>;
export type GetApiUsersAuditLogQueryError = unknown;

export function useGetApiUsersAuditLog<TData = Awaited<ReturnType<typeof getApiUsersAuditLog>>, TError = unknown>(
  params: undefined | GetApiUsersAuditLogParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersAuditLog>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getApiUsersAuditLog>>, TError, Awaited<ReturnType<typeof getApiUsersAuditLog>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersAuditLog<TData = Awaited<ReturnType<typeof getApiUsersAuditLog>>, TError = unknown>(
  params?: GetApiUsersAuditLogParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersAuditLog>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersAuditLog>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersAuditLog>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersAuditLog<TData = Awaited<ReturnType<typeof getApiUsersAuditLog>>, TError = unknown>(
  params?: GetApiUsersAuditLogParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersAuditLog>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUsersAuditLog<TData = Awaited<ReturnType<typeof getApiUsersAuditLog>>, TError = unknown>(
  params?: GetApiUsersAuditLogParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersAuditLog>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersAuditLogQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postApiUsersAppVersion = (
  appDeviceVersionRequest: AppDeviceVersionRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `/api/Users/AppVersion`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: appDeviceVersionRequest,
      signal
    },
    options
  );
};

export const getPostApiUsersAppVersionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiUsersAppVersion>>, TError, { data: AppDeviceVersionRequest }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersAppVersion>>, TError, { data: AppDeviceVersionRequest }, TContext> => {
  const mutationKey = ['postApiUsersAppVersion'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersAppVersion>>, { data: AppDeviceVersionRequest }> = (props) => {
    const { data } = props ?? {};

    return postApiUsersAppVersion(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUsersAppVersionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersAppVersion>>>;
export type PostApiUsersAppVersionMutationBody = AppDeviceVersionRequest;
export type PostApiUsersAppVersionMutationError = unknown;

export const usePostApiUsersAppVersion = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiUsersAppVersion>>, TError, { data: AppDeviceVersionRequest }, TContext>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof postApiUsersAppVersion>>, TError, { data: AppDeviceVersionRequest }, TContext> => {
  const mutationOptions = getPostApiUsersAppVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getApiUsersAppVersion = (
  params?: GetApiUsersAppVersionParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>({ url: `/api/Users/AppVersion`, method: 'GET', params, signal }, options);
};

export const getGetApiUsersAppVersionQueryKey = (params?: GetApiUsersAppVersionParams) => {
  return [`/api/Users/AppVersion`, ...(params ? [params] : [])] as const;
};

export const getGetApiUsersAppVersionQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersAppVersion>>, TError = unknown>(
  params?: GetApiUsersAppVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersAppVersion>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersAppVersionQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersAppVersion>>> = ({ signal }) =>
    getApiUsersAppVersion(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersAppVersion>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiUsersAppVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersAppVersion>>>;
export type GetApiUsersAppVersionQueryError = unknown;

export function useGetApiUsersAppVersion<TData = Awaited<ReturnType<typeof getApiUsersAppVersion>>, TError = unknown>(
  params: undefined | GetApiUsersAppVersionParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersAppVersion>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersAppVersion>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersAppVersion>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersAppVersion<TData = Awaited<ReturnType<typeof getApiUsersAppVersion>>, TError = unknown>(
  params?: GetApiUsersAppVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersAppVersion>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersAppVersion>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersAppVersion>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersAppVersion<TData = Awaited<ReturnType<typeof getApiUsersAppVersion>>, TError = unknown>(
  params?: GetApiUsersAppVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersAppVersion>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUsersAppVersion<TData = Awaited<ReturnType<typeof getApiUsersAppVersion>>, TError = unknown>(
  params?: GetApiUsersAppVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersAppVersion>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersAppVersionQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
